import { AxiosError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { ApiErrorCode } from './ApiError';

const FORBIDDEN_FALLBACK =
  "You don't have permission to do that. If you think this is wrong, contact a Kit Keeper admin.";
const UNAUTHORIZED_FALLBACK =
  'Your session has expired. Please sign in again to continue.';

function messageFromCode(code: ApiErrorCode, requestId?: string): string {
  switch (code) {
    case 'UNAUTHENTICATED':
      return UNAUTHORIZED_FALLBACK;
    case 'FORBIDDEN':
      return FORBIDDEN_FALLBACK;
    case 'NOT_FOUND':
      return 'The item you were looking for could not be found.';
    case 'VALIDATION_FAILED':
      return "Please check the details you've entered and try again.";
    case 'CONFLICT':
      return 'This item was updated by someone else. Please refresh and try again.';
    case 'RATE_LIMITED':
      return 'Too many requests. Please wait a moment and try again.';
    case 'EXTERNAL_FAILURE':
      return "We couldn't reach an external service right now. Please try again in a moment.";
    case 'INTERNAL_ERROR':
      return requestId
        ? `Something went wrong. We've logged it. Reference: ${requestId}.`
        : "Something went wrong. Please try again.";
    case 'MAINTENANCE':
      return 'Kit Keeper is currently undergoing maintenance. Please try again shortly.';
  }
}

export default function errorMessage(
  setNetworkError: Dispatch<SetStateAction<string | undefined>>,
) {
  return (error: string | Error | AxiosError) => {
    const jsonError = JSON.parse(JSON.stringify(error));
    let errorMessage: string;

    if (jsonError.hasOwnProperty('config')) {
      const axiosError = error as AxiosError;
      const status = axiosError.response?.status;
      const data = axiosError.response?.data;
      const code: ApiErrorCode | undefined = data?.code;
      const requestId: string | undefined = data?.requestId;

      if (code) {
        errorMessage = messageFromCode(code, requestId);
      } else {
        const backendMessage = data?.error || data?.message;
        if (status === 403) {
          errorMessage = backendMessage || FORBIDDEN_FALLBACK;
        } else if (status === 401) {
          errorMessage = backendMessage || UNAUTHORIZED_FALLBACK;
        } else {
          errorMessage =
            backendMessage || 'An unexpected error occurred. Please try again.';
        }
      }
    } else if (jsonError.hasOwnProperty('message')) {
      errorMessage = (error as Error).message;
    } else {
      errorMessage = error as string;
    }

    console.error(errorMessage);
    setNetworkError(errorMessage);
  };
}
